import { GRAPH_COOL_CONFIG } from '../app/config/graph-cool-variables.prod';
import { AUTH_CONFIG } from '../app/config/auth0-variables.prod';

export const environment = {
	production: true,
	version: '2.0.24',
	rootUrl: 'https://www.mobil-it.com/',
	auth0Config: AUTH_CONFIG,
	//stripeConfig: STRIPE_CONFIG,
	graphCoolConfig: GRAPH_COOL_CONFIG
};

//Raven.config(SENTRY_CONFIG.projectEndPoint, {release: environment.version}).install();

export function logError(error) {
	//Raven.captureException(error.originalError || error);
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/environments/environment.ts